import { render, staticRenderFns } from "./dataSet.vue?vue&type=template&id=68fd0470"
import script from "./dataSet.vue?vue&type=script&lang=js"
export * from "./dataSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports